import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './ageverif.css';

const AgeVerification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [domain, setDomain] = useState('');

  useEffect(() => {
    
    const ageVerified = localStorage.getItem('ageVerified');
    if (!ageVerified) {
      setIsVisible(true);
      
      document.body.style.overflow = 'hidden';
    }

    
    setDomain(window.location.hostname);

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        handleNo();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      
      document.body.style.overflow = 'auto';
    };
  }, []);

  const handleYes = () => {
    localStorage.setItem('ageVerified', 'true');
    setIsVisible(false);
    
    document.body.style.overflow = 'auto';
  };

  const handleNo = () => {
    
    window.location.href = 'https://www.google.com'; 
  };

  if (!isVisible) return null;

  return ReactDOM.createPortal(
    <div
      className="age-verification-overlay"
      role="dialog"
      aria-labelledby="age-verification-title"
      aria-describedby="age-verification-description"
    >
      <div className="age-verification-modal">
        <div className="modal-content">
          <h2 id="age-verification-title">Вам уже исполнилось 18 лет?</h2>
          <p id="age-verification-description">
            Сайт "{domain}" рассчитан на посетителей старше 18 лет. Пожалуйста, подтвердите свой возраст.
          </p>
        </div>
        <div className="button-container">
          <button className="age-button no-button" onClick={handleNo}>Нет</button>
          <button className="age-button yes-button" onClick={handleYes}>Да</button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AgeVerification;
